module.exports = __webpack_public_path__ + "static/media/tech.7721296a.png";